<template>
    <div
        key="AppLayoutDashboard"
        class="flex h-full w-full text-sm font-text text-app-font-500 dark:text-app-font-dark-500"
    >
        <the-sidebar />
        <the-content>
            <the-header />
            <the-main>
                <slot />
            </the-main>
        </the-content>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TheHeader from '@/common/components/TheHeader.vue'
import TheSidebar from '@/common/components/TheSidebar.vue'
import TheContent from '@/common/components/TheContent.vue'
import TheMain from '@/common/components/TheMain.vue'

export default defineComponent({
    name: 'AppLayoutDashboard',
    components: {
        TheHeader,
        TheSidebar,
        TheContent,
        TheMain,
    },
})
</script>
